// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bd92557f","239":"3e736dab","450":"edf547de","453":"56149047","455":"3e89af3e"}[chunkId] + ".chunk.js";
};